import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { StoreLayout } from './components/StoreLayout';
import { Home } from './pages/Home';
import { Catalog } from './pages/Catalog';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { Account } from './pages/Account';
import { Confirmation } from './pages/Confirmation';
import { Admin } from './pages/Admin';
import { Login } from './pages/Login';
export function App() {
  return <CartProvider data-id="element-0" data-mp="31b8j3x6zk98o">
      <BrowserRouter data-id="element-1" data-mp="31bs1tg4gn1nr">
        <Routes data-id="element-2" data-mp="31c9uk2rwyxqx">
          <Route element={<StoreLayout data-id="element-4" data-mp="2wk0a329kipw1" />} data-id="element-3" data-mp="31ctflscv2296">
            <Route path="/" element={<Home data-id="element-6" data-mp="2wj8f9tnsow6t" />} data-id="element-5" data-mp="2wjqhr811w6n6" />
            <Route path="/index" element={<Home data-id="element-8" data-mp="28u5yeo0zj7dd" />} data-id="element-7" data-mp="2whx9xpepbgdl" />
            <Route path="/productos" element={<Catalog data-id="element-10" data-mp="28sl32w6ujkeg" />} data-id="element-9" data-mp="28tme50nv46w6" />
            <Route path="/producto/:slug" element={<ProductDetail data-id="element-12" data-mp="23w4ek0vqj40u" />} data-id="element-11" data-mp="28s30zixi6bym" />
            <Route path="/mis-pedidos" element={<Account data-id="element-14" data-mp="3ijxoypkvdyjd" />} data-id="element-13" data-mp="23v2r0wxj8p28" />
            <Route path="/carrito" element={<Cart data-id="element-16" data-mp="3ijfunyhrpue3" />} data-id="element-15" data-mp="3ikqy1x7ax04o" />
            <Route path="/checkout" element={<Checkout data-id="element-18" data-mp="3ml12v6jcxkhy" />} data-id="element-17" data-mp="3ii4sg33z0up3" />
            <Route path="/confirmacion" element={<Confirmation data-id="element-20" data-mp="3mj6ipufwtwex" />} data-id="element-19" data-mp="3mk852v2dm5by" />
          </Route>
          <Route path="/login" element={<Login data-id="element-22" data-mp="3rd1azm9kzjpm" />} data-id="element-21" data-mp="3rdaquh0wwahl" />
          <Route path="/admin" element={<Admin data-id="element-24" data-mp="6hovayao7c0" />} data-id="element-23" data-mp="3relv0hy9rk98" />
        </Routes>
      </BrowserRouter>
    </CartProvider>;
}